var map = {
  "./cs.json": [
    "Mk4",
    [
      "qd"
    ]
  ],
  "./en.json": [
    "ldS",
    [
      "v2"
    ]
  ],
  "./pl.json": [
    "s7V",
    [
      "2ph"
    ]
  ],
  "./ru.json": [
    "QDo",
    [
      "a9"
    ]
  ],
  "./tr.json": [
    "bv",
    [
      17
    ]
  ],
  "./ja.json": [
    "AM",
    [
      "a8"
    ]
  ],
  "./zh.json": [
    "MWQ",
    [
      "uu"
    ]
  ],
  "./pt-br.json": [
    "r5d",
    [
      992
    ]
  ],
  "./de.json": [
    "wZw",
    [
      "ig6"
    ]
  ],
  "./es.json": [
    "Uto",
    [
      "ufk"
    ]
  ],
  "./fr.json": [
    "mFK",
    [
      "ge"
    ]
  ],
  "./it.json": [
    "kzl",
    [
      "m05"
    ]
  ],
  "./ko.json": [
    "Vd",
    [
      "bg"
    ]
  ],
  "./pt.json": [
    "oQt",
    [
      "q9"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "pl";
module.exports = __rspack_async_context;
